import useApiPrivateClient from '../../../hooks/useApiPrivateClient';
import {
  CreateDiscountTierData,
  UpdateDiscountTierData,
} from './discountTier.requests';
import { DiscountTier, DiscountTierDetail } from './discountTier.responses';

const useDiscountTierService = () => {
  const api = useApiPrivateClient();

  const listDiscountTiers = () =>
    api.get<DiscountTier[]>('/payments/discount-tiers');

  const getDiscountTier = (code: string) =>
    api.get<DiscountTierDetail>(`/payments/discount-tiers/${code}`);

  const createDiscountTier = (data: CreateDiscountTierData) =>
    api.post<DiscountTier>('/payments/discount-tiers', data);

  const updateDiscountTier = (code: string, data: UpdateDiscountTierData) =>
    api.patch<DiscountTier>(`/payments/discount-tiers/${code}`, data);

  const deactivateDiscountTier = (code: string) =>
    api.delete<DiscountTier>(`/payments/discount-tiers/${code}`);

  return {
    listDiscountTiers,
    getDiscountTier,
    createDiscountTier,
    updateDiscountTier,
    deactivateDiscountTier,
  };
};

export default useDiscountTierService;
